import { useTranslation } from "react-i18next";

// The small grey line above a splash screen ("🔬 Your profile is coming into
// focus"). makeSplashHeader("splash.headers.bodyType") gives the page's
// customHeader component.
export function makeSplashHeader(key: string) {
  const SplashHeader = () => {
    const { t } = useTranslation();
    return (
      <div style={{
        padding: "8px 0 5px 0",
        background: "white",
        textAlign: "center",
        color: "#7A7A7A",
        fontSize: "12px",
      }}>
        {t(key)}
      </div>
    );
  };
  return SplashHeader;
}
